import type { SelectChangeEvent } from '@all-manager/design-system-v2';
import type { StatusFilter, TopicListPage } from '../../pages/useTopicListPage';

export function useTopicListPanel(page: TopicListPage) {
  function handleStatusFilterChange(event: SelectChangeEvent<StatusFilter>) {
    page.setTopicStatusFilter(event.target.value as StatusFilter);
  }

  return {
    handleStatusFilterChange,
    isEmpty: page.topics.length === 0,
    noResultSubtitle: page.topicSearch.trim()
      ? `Aucun sujet ne correspond à « ${page.topicSearch.trim()} ».`
      : 'Aucun sujet ne correspond à ce statut.',
  };
}
